module.exports = __webpack_public_path__ + "static/media/019.04c10389.jpg";